import type { Entity } from '../../types/api';

export const HIDDEN_KEYS = new Set(['aggregate_specs', 'aggregate specs']);

export const isMissing = (value: any): boolean => {
  return value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
};

export const formatText = (text: string): string => {
  return text
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatColumnHeader = (key: string): string => {
  return formatText(key);
};

export const formatCellValue = (value: any): string => {
  if (isMissing(value)) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value).replace(/_/g, ' ');
};

export const getKeysForType = (typeEntities: Entity[]): { configKeys: string[]; metadataKeys: string[] } => {
  const configKeys = new Set<string>();
  const metadataKeys = new Set<string>();

  typeEntities.forEach(entity => {
    const configuration = entity.configuration || {};
    const metadata = entity.entity_metadata || entity.metadata || entity.properties || {};

    Object.keys(configuration).forEach(key => {
      if (!HIDDEN_KEYS.has(key.toLowerCase())) configKeys.add(key);
    });
    Object.keys(metadata).forEach(key => {
      if (!HIDDEN_KEYS.has(key.toLowerCase())) metadataKeys.add(key);
    });
  });

  return {
    configKeys: Array.from(configKeys).sort(),
    metadataKeys: Array.from(metadataKeys).sort()
  };
};

export const hasValuesInType = (typeEntities: Entity[], key: string): boolean => {
  return typeEntities.some(entity => {
    const metadata = entity.entity_metadata || entity.metadata || entity.properties || {};
    return !isMissing(metadata[key]);
  });
};

export const exportToJSON = (entities: Entity[]) => {
  const exportData = entities.map(entity => ({
    name: entity.name || entity.entity_name,
    id: entity.id || entity.entity_id,
    type: entity.concept_category || entity.entity_type_name,
    asset_tag: entity.asset_tag,
    status: entity.status,
    installation_date: entity.installation_date,
    metadata: entity.entity_metadata || entity.metadata || {}
  }));

  const dataStr = JSON.stringify(exportData, null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });
  const url = URL.createObjectURL(dataBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `components-export-${new Date().toISOString().split('T')[0]}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
